export default __webpack_public_path__ + "static/about2-e9d47ae60322c1d90d41ac9cd25fb52b.png";